// extracted by mini-css-extract-plugin
export default {"root":"PageHeader_root__1tjkh","text":"PageHeader_text__Ityql","title":"PageHeader_title__YDhmh","subtitle":"PageHeader_subtitle__9M7NJ","actions":"PageHeader_actions__2m0tc"};